import { render, staticRenderFns } from "./hyzx.vue?vue&type=template&id=6d88eb95&"
import script from "./hyzx.vue?vue&type=script&lang=js&"
export * from "./hyzx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports